import React, { useState } from 'react';
import className from 'classnames';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import FontIcon from 'components/FontIcon';
import InstructorB from 'components/Instructor/InstructorB';
import ModalB from 'components/Modal/ModalB';
import SeminarDetailsModal from 'components/SeminarDetails/SeminarDetailsModal';
import SeminarLocation from 'components/SeminarDetails/SeminarLocation';
import SeminarDateTime from 'components/SeminarDetails/SeminarDateTime';
import BuildChildren from 'utils/BuildChildren';
import { buildProductListStructuredData } from 'utils/StructuredData';
import classes from './SeminarSchedulerA.module.scss';

const SeminarSchedulerA = (props) => {
  const {
    onClick,
    title,
    items = [],
    showProducts,
    selectedProductModal,
    openProductModal,
    closeProductModal,
  } = props;

  const structuredData = buildProductListStructuredData(items);
  const hasOverrideButtons = items.some((i) => !isEmpty(i.overrideButton));
  const [isOpen, setIsOpen] = useState(false);
  const [selectedInstructor, setSelectedInstructor] = useState(null);

  const toggleModal = (e, instructorObj) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOpen(!isOpen);
    setSelectedInstructor(instructorObj);
  };

  return (
    <div className={classes.container}>
      <Modal
        isOpen={isOpen}
        onRequestClose={(e) => toggleModal(e, null)}
        shouldCloseOnOverlayClick={false}
        ariaHideApp={false}
        className={classes.modal}
        overlayClassName={classes.overlayModal}
        closeTimeoutMS={250}
      >
        <ModalB hideModal={(e) => toggleModal(e, null)}>
          <InstructorB {...selectedInstructor} title='Instructor BIO' />
        </ModalB>
      </Modal>
      <script
        type='application/ld+json'
        dangerouslySetInnerHTML={{ __html: structuredData }}
      />
      <button
        aria-label={showProducts ? 'Hide Products' : 'Show Products'}
        className={classes.titleButton}
        onClick={onClick}
        type='button'
      >
        <FontIcon
          icon={showProducts ? 'far fa-minus-circle' : 'far fa-plus-circle'}
          className={classes.icon}
        />
        <span
          className={classes.title}
          dangerouslySetInnerHTML={{ __html: title }}
        />
      </button>
      {showProducts &&
        <div className={className(classes.row, classes.headerRow)}>
          <div className={classes.columnHeader} />
          <div className={classes.columnHeader}>Schedule</div>
          <div className={classes.columnHeader}>Location</div>
          <div className={classes.columnHeader}>Instructor</div>
          {hasOverrideButtons && <div className={classes.columnHeader} />}
        </div>}
      {items.length > 0 &&
        items.map((i) => {
          const {
            productId,
            displayName,
            overrideButton,
            seminarInfo,
          } = i;

          const {
            venue,
            street,
            city,
            state,
            postalCode,
            start,
            end,
            timeZone,
            sessions = [],
            instructor,
            instructorsDetails = [],
          } = seminarInfo || {};

          const renderInstructor = () => (
            (instructorsDetails && instructorsDetails.map((obj, idx) => {
              const { name, title: instructorTitle } = obj;
              const exists = !isEmpty(instructorTitle);
              const br = idx > 0 ? <br /> : null;
              const instructorContent = (exists && (
                <button
                  className={classes.instructorButton}
                  type='button'
                  onClick={(e) => toggleModal(e, obj)}
                >
                  <div dangerouslySetInnerHTML={{ __html: name }} />
                </button>
              )) || <div dangerouslySetInnerHTML={{ __html: name }} />;
              return (
                <div key={`${name}-${idx}`}>
                  {instructorContent}
                  {br}
                </div>
              );
            })) || (instructor &&
              <div>
                {instructor}
              </div>
            )
          );

          return (
            <div className={!showProducts && classes.hideContent}>
              <div className={classes.row} key={`product_${productId}`}>
                <div
                  className={classes.productDisplayName}
                  dangerouslySetInnerHTML={{ __html: displayName }}
                />
                <div className={classes.cellLabel}>SCHEDULE</div>
                <div>
                  <SeminarDateTime
                    startDate={start}
                    endDate={end}
                    timeZone={timeZone}
                  />
                  <button
                    aria-label='View All'
                    onClick={() => openProductModal(productId)}
                    className={classes.gridLink}
                    type='button'
                  >
                    View All
                  </button>
                </div>
                <div className={classes.cellLabel}>LOCATION</div>
                <div>
                  <SeminarLocation
                    venue={venue}
                    street={street}
                    city={city}
                    state={state}
                    postalCode={postalCode}
                    venueClass={classes.venue}
                    addressClass={classes.address}
                    linkClass={classes.gridLink}
                  />
                </div>
                <div className={classes.cellLabel}>INSTRUCTOR</div>
                <div className={classes.gridValue}>
                  {renderInstructor()}
                </div>
                {hasOverrideButtons &&
                  <div className={overrideButton && classes.productButtonContainer}>
                    {BuildChildren(overrideButton)}
                  </div>}
                {sessions.length > 0 &&
                  <SeminarDetailsModal
                    displayName={displayName}
                    sessions={sessions}
                    isOpen={selectedProductModal === productId}
                    closeModal={closeProductModal}
                    timeZone={timeZone}
                  />}
              </div>
            </div>
          );
        })}
    </div>
  );
};

SeminarSchedulerA.propTypes = {
  onClick: PropTypes.func,
  title: PropTypes.string,
  items: PropTypes.array,
  showProducts: PropTypes.bool,
  selectedProductModal: PropTypes.number,
  openProductModal: PropTypes.func,
  closeProductModal: PropTypes.func,
};

export default SeminarSchedulerA;
